var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { base } from "../themes/base";
import Box from "../box/Box";
import Text from "../text/Text";
var PageSection = function (_a) {
    var heading = _a.heading, _b = _a.isScreenReaderOnly, isScreenReaderOnly = _b === void 0 ? false : _b, headingColor = _a.headingColor, body = _a.body, bodyColor = _a.bodyColor, _c = _a.textAlign, textAlign = _c === void 0 ? "center" : _c, borderColor = _a.borderColor, children = _a.children, rest = __rest(_a, ["heading", "isScreenReaderOnly", "headingColor", "body", "bodyColor", "textAlign", "borderColor", "children"]);
    var borderProps = borderColor
        ? {
            borderColor: borderColor,
            borderTop: "1px solid",
            borderBottom: "1px solid",
        }
        : {};
    return (React.createElement(Box, __assign({ as: "section", className: "oui-page-section", py: [6, 6, 6, 7], px: 4 }, borderProps, rest),
        heading && (React.createElement(Text, { className: isScreenReaderOnly ? "sr-only" : "", as: "h2", typeStyle: "title02", textAlign: textAlign, color: headingColor, mb: heading && !body ? 6 : 0 }, heading)),
        body && (React.createElement(Text, { as: "p", typeStyle: "body", textAlign: textAlign, color: bodyColor, maxWidth: "640px", mt: 2, mx: textAlign === "center" ? "auto" : undefined, mb: 6 }, body)),
        children && (React.createElement(Box, { maxWidth: base.gridMaxWidth, mx: "auto", position: "relative" }, children))));
};
export default PageSection;
//# sourceMappingURL=PageSection.js.map